import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { Observable } from 'rxjs';
import { WaybillOverviewData } from '../../models/waybill-overview.model';
import { WaybillOverviewState } from './waybill-overview.state';
import { WaybillOverviewLoad, WaybillOverviewSetInitialState } from './waybill-overview.actions';

@Injectable({ providedIn: 'root' })
export class WaybillOverviewFacade implements LoadDataFacade, SetInitialStateFacade {
  loaded$: Observable<boolean> = this.store.select(WaybillOverviewState.getLoaded);
  overview$: Observable<WaybillOverviewData> = this.store.select(WaybillOverviewState.getOverview);

  constructor(private store: Store) {}

  loadAll(internalWaybillId: string): void {
    this.store.dispatch(new WaybillOverviewLoad(internalWaybillId));
  }

  setInitialState(): void {
    this.store.dispatch(new WaybillOverviewSetInitialState());
  }
}
